import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-111a3446"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "date-sch table-page"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FullCalendar = _resolveComponent("FullCalendar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_FullCalendar, {
    ref: "myCalendar",
    options: $data.calendarOptions
  }, null, 8, ["options"])]);
}